module.exports = __webpack_public_path__ + "static/media/menu.ca394ec8.svg";